export default "__VITE_ASSET__CYQDF0AQ__"